import { render } from "./CustomAdsCard.vue?vue&type=template&id=efc07b38&scoped=true"
import script from "./CustomAdsCard.vue?vue&type=script&lang=js"
export * from "./CustomAdsCard.vue?vue&type=script&lang=js"

import "./customAdsCartStyle.scss?vue&type=style&index=0&id=efc07b38&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc07b38"]])

export default __exports__